<template>
  <div class="modal fade selectionModal" id="selectionModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog  modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <form v-on:submit.prevent="saveSelections()"  method="POST">
          <div class="modal-body">
            <div class="row row-data">
              <div class="col-12 pro-style">Neues Projekt anlegen</div>
              <div class="col-lg-5 col-md-5 col-sm-5 col-2nd">
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <label class="form-label">Projektname *</label>
                    <div class="input-group">
                      <input class="input--style-2" type="text" v-model="selected_data.title" placeholder="Neubau Musterhausen" name="name">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                    <label class="form-label">Datum *</label>
                    <div class="input-group d-flex mr-2"  data-date-format="dd.mm.yyyy">
                      <span class="input-group-addon  mt-1 mr-1"><i class="fa fa-calendar text-dark"></i></span>
                      <input id="datepicker3" class="input--style-2 date-input text-dark" v-model="selected_data.cr_date" name="cr_date"  type="text"  style="width: 90%;">
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-6 col-3rd">
                <div class="row">
                  <div class="custom-control custom-checkbox mb-3 custom-check">
                    <input type="checkbox" v-model="is_category" class="custom-control-input" id="customCheck1" name="example1">
                    <label class="custom-control-label lb-dn form-label" for="customCheck1">Als Test- / Demoprojekt anlegen</label>
                  </div>
                </div>
                <div class="form-group">
                  <select  class="cus-select1" v-model="selected_data.id" size="6" :disabled="!is_category">
                    <option v-for="s in selections" v-on:click="setCat(s.selection)" :value="s.id">
                      {{s.title}}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="modal-photo-sec row-data overflow row">
              <div class="col-lg-11 col-md-11 col-sm-11">
                <h6 class="border-bottom py-2 mb-3">Demoprojekt anlegen</h6>
                <ul class=" img-thumb-list"  v-for="img in selectedPhots">
                  <li><img height="40" width="40" class="rounded" :src="img.src" alt="img1"></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="modal-footer mf-1st">
            <button type="button" class="btn mode-d btn-red" data-dismiss="modal">Abbrechen</button>
            <button type="submit"  class="btn btn-primary mode-s" >Projekt anlegen
            </button>
            <div class="cross-close" data-dismiss="modal"><img src="@/assets/images/cross.png"></div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../../../utils/axiosinstance'
// import axios from 'axios'
export default {
  name: 'SelectionModal',
  props: ['selectedPhots'],
  data () {
    return {
      getFiltersUrl: process.env.VUE_APP_BASE_URL + 'project/' + this.$route.params.id + '/photos/getselections',
      saveSelectionUrl: process.env.VUE_APP_BASE_URL + 'project/' + this.$route.params.id + '/photos/saveselection',
      selections: [],
      is_category: false,
      selected_cat: [],
      request_header: {
        apitoken: localStorage.apikey,
        deviceid: 'string',
        accept: 'application/json'
      },
      selected_data: {
        selection: [],
        title: '',
        cr_date: '',
        id: ''
      }
    }
  },
  mounted () {
    $('#datepicker3').datepicker({
      autoclose: true,
      todayHighlight: true,
      format: 'dd.mm.yyyy'
    })
  },
  created () {
    this.selected_data.cr_date = this.dateToday()
    // this.getSelections()
  },
  methods: {
    async saveSelections () {
      let today = this.dateToday()
      let selection_ary = []
      let selections = this.$parent.selectedPhots
      selections.forEach(value => {
        if (!this.selected_cat.includes(value.id)) {
          selection_ary.push(value.id)
        }
      })
      this.selected_data.selection = selection_ary
      this.selected_data.cr_date = today
      await this.storeSelections(this.selected_data)
    },

    setCat (data) {
      this.selected_cat = data
    },

    storeSelections (form_data) {
      axios.post(this.saveSelectionUrl, form_data, {
        headers: this.request_header
      }).then(res => {
        if (res.status === 200) {
          this.$parent.msg.push('Die Sammlung wurde erfolgreich erstellt.')
          $('#selectionModal').modal('toggle')
        } else {
          this.$parent.errors.push('Oops ... !  Something Went Wrong.')
        }
      })
    },

    getSelections () {
      axios.get(this.getFiltersUrl, {
        headers: this.request_header
      })
        .then(response => {
          if (response.status === 200) {
            this.selections = response.data.data.selections
          } else {
            this.$parent.errors.push('Oops ... !  Something Went Wrong.')
          }
        })
    },

    dateToday () {
      let today = new Date()
      let dd = today.getDate()
      let mm = today.getMonth() + 1
      let yyyy = today.getFullYear()
      return dd + '.' + mm + '.' + yyyy
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/photo/components/SelectionModal.vue